import { Box, Card, FormControl, MenuItem, Select } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useState } from "react";
import { CustomNoRowsOverlay } from "../Assessment.js";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../components/common/customPagination.jsx";

function ClientRemediationTable({ remediationListData, loader, type }) {
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const handlePaginationModelChange = (newPaginationModel) => {
        setPaginationModel(newPaginationModel);
    };


    let columns = [
        {
            field: "id",
            headerName: "#",
            flex: 0.5,
            sortable: false,
            className: "serial-number",
            disableColumnMenu: true,
        },
        {
            field: "uniqueId",
            headerName: "ID",
            flex: 1,
            sortable: false,
            disableColumnMenu: true,
        },
        {
            field: "issueName",
            hide: true,
            headerName: "Issue Name",
            flex: 1.2,
            disableColumnMenu: true,
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            disableColumnMenu: true,
        },
        {
            field: "severity",
            headerName: "Severity",
            flex: 1,
            disableColumnMenu: true,
            renderCell: (params) => {
                const severity = params.value?.toLowerCase();
                let scoreTag = "-";
                if (severity === 'low') {
                    scoreTag = "Low";
                } else if (severity === 'medium') {
                    scoreTag = "Medium";
                } else if (severity === 'critical') {
                    scoreTag = "Critical";
                } else if (severity === 'high') {
                    scoreTag = "High";
                }
                if (!severity) return "-";
                return (
                    scoreTag ? (
                        <span className={`tagClassapproval blank-white ${scoreTag}`}>
                            <span>{scoreTag}</span>
                        </span>
                    ) : (
                        "-"
                    )
                );
            },
        },
        {
            field: "startDate",
            headerName: "Sent Date",
            flex: 1,
            disableColumnMenu: true,
            valueFormatter: (params) => {
                return moment.unix(params.value).format("DD MMM YYYY");
            }
        },
        {
            field: "isPending",
            headerName: "Status",
            aling: "right",
            headerAlign: "center",
            flex: 0.8,
            disableColumnMenu: true,
            renderCell: (params) => {
                let status = params.value;
                return (
                    <div style={{ display: "flex", justifyContent: "right", width: "100%" }}>
                        {status === true ?
                            <span className={`statusClass ${status}`} style={{ "minWidth": "120px" }}>{'Pending'}</span>
                            :
                            <span className={`statusClass Onboarding`} style={{ "minWidth": "120px" }} >{'Done'}</span>
                        }
                    </div>
                )
            },
        }
    ];

    if (type === "ForGaps") {
        columns = columns.filter((item) => item.field != "issueName")
    }
    if (type === "ForQuestionnaire") columns.splice(3, 0, {
        field: "assessmentName",
        headerName: "Assessment Name",
        flex: 1.2,
        disableColumnMenu: true,
    })
    const handleRowClick = (params) => {
        navigate(`/dashboard/remediation-details`, { state: { Data: params.row } })
    };

    return (
        <>
            <Card className="full-coverdesign margin-questionnaire">
                <div className="cover-table">
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            top: "4px",
                            left: "5px",

                        }}
                    >
                        <FormControl
                            className="select-entries"
                            variant="outlined"
                            size="small"
                        >
                            <Select
                                value={paginationModel.pageSize}
                                onChange={(e) => handlePaginationModelChange({ page: 0, pageSize: e.target.value })}
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                            </Select>
                        </FormControl>
                        <span className="entries-per">entries per page</span>{" "}
                    </div>
                    <div className="issues-tab-table">
                        <Box
                            sx={{
                                width: "100%",
                                "& .MuiDataGrid-columnHeaders": {
                                    minWidth: "100%",
                                    overflowX: "hidden",
                                },
                                "& .MuiDataGrid-virtualScroller": {
                                    minWidth: "100%",
                                    overflowX: "auto",
                                },
                            }}
                        >

                            <DataGrid
                                rows={remediationListData}
                                columns={columns}
                                loading={loader}
                                rowHeight={70}
                                onPaginationModelChange={handlePaginationModelChange}
                                paginationModel={paginationModel}
                                pageSizeOptions={[5, 10, 25]}
                                slots={{
                                    toolbar: GridToolbar,
                                    noRowsOverlay: CustomNoRowsOverlay,
                                    pagination: CustomPagination,
                                }}
                                slotProps={{
                                    pagination: {
                                        paginationModel,
                                        onPaginationModelChange: handlePaginationModelChange,
                                        rowCount: remediationListData?.length
                                    },
                                }}
                                disableRowSelectionOnClick
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector
                                disableColumnMenu
                                paginationMode="client"
                                disableSelectionOnClick
                                autoHeight
                                className="datagrid-table click-hover-datagrid"
                                sx={{
                                    "& .MuiDataGrid-columnHeaders": {
                                        minWidth: "100%", // Column headers take up full width
                                    },
                                    "& .MuiDataGrid-virtualScroller": {
                                        minWidth: "100%", // Rows take up full width
                                    },
                                }}
                                onRowClick={handleRowClick}
                            />
                        </Box>
                    </div>
                </div>
            </Card >
        </>
    );
}

export default ClientRemediationTable;